import {
  Link,
  useLocation,
  useNavigate,
  useRouteLoaderData,
} from "react-router";
import LinkArrow from "../../components/icons/LinkArrow";
import ReadMoreContainer from "../../components/ReadMoreContainer";
import { KlientkontoerklaeringByIdLoaderData } from "../klientkontoerklaering/KlientkontoerklaeringById";
import { ROUTES } from "../../constants/routes";
import PageError from "../PageError";
import { useEffect } from "react";
import { HomeLoaderResponse } from "../../interfaces/loaders";

export default function IntroSluterklaering() {
  //r001
  const navigate = useNavigate();
  const { kke, error } = useRouteLoaderData(
    ROUTES.sluterklaering.id,
  ) as KlientkontoerklaeringByIdLoaderData;
  const { userInfo } = useRouteLoaderData(
    ROUTES.homeIndex.id,
  ) as HomeLoaderResponse;
  const location = useLocation();

  useEffect(() => {
    if (userInfo.role === "TokenUser") {
      const kkeId = kke?.id;
      navigate(`/sluterklaering/${kkeId}/tilsvar`);
    }
  }, [navigate, kke, userInfo.role]);

  if (error) return <PageError />;
  if (kke?.status && kke.status !== "Kladde")
    return <PageError msg={`Erklæringen er ${kke.status.toLowerCase()}`} />;
  return (
    <>
      <h1
        className="pb-4
       display-1"
      >
        Sluterklæring
      </h1>
      <div className="row">
        <div className="col-12 col-xl-9">
          <ReadMoreContainer maxLength={12}>
            <p>
              Her skal du indsende klientkontoerklæring i forbindelse med
              deponering eller ved et selskabs ophør som advokatselskab.
              Erklæringen dækker perioden fra sidste årlige erklæring (01.01.)
              og frem til deponering/ophør. Hvis du vil have en mailkvittering
              ved indsendelsen, skal du huske at indtaste din mailadresse i
              forbindelse med MitID-godkendelsen af erklæringen. Erklæringen
              sendes TLS-krypteret under forudsætning af, at den indtastede
              mailadresse understøtter TLS.
            </p>
            <h2 className="display-4 fw-semibold mt-4">Advokat</h2>
            <h3 className="h5 mt-2">Formular I</h3>
            <p>
              Hvis du i løbet af året har haft tilsvar af betroede midler, skal
              du indgive erklæring på Formular I med oplysninger og attestation
              fra en statsautoriseret eller registreret revisor. Det er
              hovedsaligt advokater, som driver deres advokatvirksomhed som
              henholdsvis en enkeltmandsvirksomhed eller som et interessentskab,
              der har tilsvar af betroede midler.
            </p>
            <p>
              Bemærk, at du ikke længere må være i besiddelse af betroede
              midler, når beskikkelsen er deponeret. Saldoen for det samlede
              tilsvar pr. ophørsdagen skal derfor være 0 kr.
            </p>
            <h3 className="h5 mt-2">Formular II</h3>
            <p>
              Hvis du var ansat advokat eller drev advokatvirksomhed i
              selskabsform, har du typisk ikke haft betroede midler, og så skal
              du indgive erklæring på Formular II.
            </p>
            <h2 className="display-4 fw-semibold mt-4">Advokatselskab</h2>
            <h3 className="h5 mt-2">Formular I</h3>
            <p>
              Hvis selskabet i løbet af året har haft tilsvar af betroede
              midler, skal selskabet indgive erklæring på Formular I med
              oplysninger og attestation fra en statsautoriseret eller
              registreret revisor. Bemærk, at selskabet ikke længere må være i
              besiddelse af betroede midler, når det ikke længere er et
              advokatselskab. Saldoen for det samlede tilsvar pr. ophørsdagen
              skal derfor være 0 kr.
            </p>
            <h3 className="h5 mt-2">Formular II</h3>
            <p>
              Advokatholdingselskaber driver ikke advokatvirksomhed, og skal
              indgive erklæring på Formular II. Også advokatdriftsselskaber, som
              ikke har haft tilsvar, skal bruge formular II.
            </p>
            <p className="mt-4">
              Det fremgår i øverste højre hjørne, hvem du er logget ind som,
              dvs. om du er ved at indgive din personlige erklæring, eller en
              erklæring på vegne af et selskab.
            </p>
          </ReadMoreContainer>
        </div>
      </div>
      <h3 className="h4 fw-normal mt-6 mb-4">Vælg formular:</h3>
      <div className="row g-4 align-items-stretch">
        {(kke?.interessentKlienterklaeringMode ===
          "IkkeInteressentKlienterklaering" ||
          kke?.interessentKlienterklaeringMode === "IngenAndresGodkendelser" ||
          ((kke?.interessentKlienterklaeringMode === "AndreHarGodkendt" ||
            kke?.interessentKlienterklaeringMode === "AndreHarIndsendt") &&
            kke?.formularType === "Formular1")) && (
          <div className="col-lg-6 col-12">
            <Link to={`${location.pathname}/tilsvar`} className="card">
              <div className="card-body">
                <div className="d-flex gap-3 align-items-center">
                  <h3 className="display-4 text-body fw-semibold">
                    Erklæring tilsvar
                  </h3>
                  <span className="text-muted ms-auto">Formular I</span>
                  <LinkArrow />
                </div>
              </div>
            </Link>
          </div>
        )}
        {(kke?.interessentKlienterklaeringMode ===
          "IkkeInteressentKlienterklaering" ||
          kke?.interessentKlienterklaeringMode === "IngenAndresGodkendelser" ||
          ((kke?.interessentKlienterklaeringMode === "AndreHarGodkendt" ||
            kke?.interessentKlienterklaeringMode === "AndreHarIndsendt") &&
            kke?.formularType === "Formular2")) && (
          <div className="col-lg-6 col-12">
            <Link to={`${location.pathname}/intet-tilsvar`} className="card">
              <div className="card-body">
                <div className="d-flex gap-3 align-items-center">
                  <h3 className="display-4 text-body fw-semibold">
                    Erklæring - intet tilsvar
                  </h3>
                  <span className="text-muted ms-auto">Formular II</span>
                  <LinkArrow />
                </div>
              </div>
            </Link>
          </div>
        )}
      </div>
    </>
  );
}
